import { useTheme } from "next-themes";
import { BiMoon, BiSun } from "react-icons/bi";
import { useState, useEffect } from "react";
import { MdOutlineDesktopMac } from "react-icons/md";
import CustomDropDownMenu from "../FormFields/CustomDropDownMenu";
import { Button } from "@components/ui/button";

interface ThemeOption {
  icon: JSX.Element;
  value: string;
}

const _themeOptions: ThemeOption[] = [
  {
    icon: <BiMoon />,
    value: "dark",
  },
  {
    icon: <BiSun />,
    value: "light",
  },
  {
    icon: <MdOutlineDesktopMac />,
    value: "system",
  },
];

function ThemeChanger() {
  const { systemTheme, theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  function capitalizeFirstLetter(val: string) {
    return val.charAt(0).toUpperCase() + val.slice(1);
  }

  const renderThemeChanger = () => {
    if (!mounted)
      return (
        <Button size="icon" variant="ghost">
          <MdOutlineDesktopMac />
        </Button>
      );

    const currentTheme = theme === "system" ? systemTheme : theme;

    return (
      <CustomDropDownMenu
        menuButton={
          <Button size="icon" variant="ghost">
            {theme === "system" ? (
              <MdOutlineDesktopMac />
            ) : currentTheme === "dark" ? (
              <BiMoon />
            ) : (
              <BiSun />
            )}
          </Button>
        }
        menuItems={[
          {
            items: _themeOptions.map((option) => {
              return {
                title: capitalizeFirstLetter(option.value),
                icon: option.icon,
                onClick: () => {
                  setTheme(option.value);
                },
              };
            }),
          },
        ]}
      />
    );
  };

  return <div>{renderThemeChanger()}</div>;
}

export default ThemeChanger;
